import { render, staticRenderFns } from "./ContractorResendInvitationNew.vue?vue&type=template&id=4bf71501&scoped=true"
import script from "./ContractorResendInvitationNew.vue?vue&type=script&lang=ts"
export * from "./ContractorResendInvitationNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorResendInvitationNew.vue?vue&type=style&index=0&id=4bf71501&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf71501",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf71501')) {
      api.createRecord('4bf71501', component.options)
    } else {
      api.reload('4bf71501', component.options)
    }
    module.hot.accept("./ContractorResendInvitationNew.vue?vue&type=template&id=4bf71501&scoped=true", function () {
      api.rerender('4bf71501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invite/ContractorResendInvitationNew.vue"
export default component.exports